import React from 'react';
import { Day } from './Day.js';
import { StyledWeekDaysListWrapper } from './Styleds.js';
import type { DSControlledDateTimePickerT } from '../../../react-desc-prop-types.js';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';

export interface CalendarDaysListPropsT {
  invisibleFirstDay?: DSControlledDateTimePickerT.MetaMonthDay;
  daysMatrixByWeekday: DSControlledDateTimePickerT.MetaMonthDay[][];
  invisibleLastDay?: DSControlledDateTimePickerT.MetaMonthDay;
  innerRef: React.RefObject<HTMLDivElement>;
}

export const CalendarDaysList = React.memo(
  ({ invisibleFirstDay, daysMatrixByWeekday, invisibleLastDay, innerRef }: CalendarDaysListPropsT): JSX.Element => {
    const { getProps } = React.useContext(ControlledDateTimePickerContext);

    return (
      <div ref={innerRef} role="rowgroup">
        {invisibleFirstDay ? (
          <div role="row" style={{ display: 'none' }}>
            <Day key={`ds-calendar-${invisibleFirstDay.day.toString()}`} metaDay={invisibleFirstDay} isInvisible />
          </div>
        ) : null}
        {daysMatrixByWeekday.map((week, i) => (
          <StyledWeekDaysListWrapper
            key={`ds-calendar-week-${week[0].day.toString()}-${week[6].day.toString()}`}
            role="row"
            aria-rowindex={i + 1}
            cols={['2.4615rem', '2.4615rem', '2.4615rem', '2.4615rem', '2.4615rem', '2.4615rem', '2.4615rem']}
            rows={['2.1538rem']}
            py="xxxs"
            px="2px"
            justifyContent="space-between"
            alignItems="center"
            getOwnerProps={getProps}
          >
            {week.map((metaDay, z) => (
              <Day key={`ds-calendar-${metaDay.day.toString()}`} metaDay={metaDay} colIndex={z + 1} />
            ))}
          </StyledWeekDaysListWrapper>
        ))}
        {invisibleLastDay ? (
          <div role="row" style={{ display: 'none' }}>
            <Day key={`ds-calendar-${invisibleLastDay.day.toString()}`} metaDay={invisibleLastDay} isInvisible />
          </div>
        ) : null}
      </div>
    );
  },
);
